import { Component, EventEmitter, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-generic-header',
  templateUrl: './generic-header.component.html',
  styleUrl: './generic-header.component.scss',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule]
})
export class GenericHeaderComponent {
  @Input() title: string = '';
  @Input() searcher: boolean = true;
  @Input() divider: boolean = true;

  @Output() onSearch = new EventEmitter<string>();

  onChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.onSearch.emit(value);
  }
}
